import React from 'react'
import cx from 'classnames'
import { useSelector } from 'react-redux'
import { Skeleton } from '@mui/material'
import { RESPONSE_PENDING } from 'libraries/front-end-core/constants/responses'
import { TAKEOVER_INTERNAL } from 'libraries/front-end-core/constants/urls'
import getUrl from 'libraries/front-end-core/core/url'
import useObservable from 'libraries/front-end-core/hooks/useObservable'
import { LEGISLATION } from 'constants/controllers'
import { LEGISLATION_TAKEOVER_CODE } from 'constants/feature-flags'
import { requestActs } from 'services/LegislationService'
import selectIsIE from 'redux/selectors/selectIsIE'
import Icon from 'components/shared/Icon'
import ResponseConsumer from 'components/shared/ResponseConsumer'

const LegislationMenu = ({ aol }) => {
  const acts = useObservable(requestActs(aol), RESPONSE_PENDING)

  return (
    <div className='pb9 bg-page-background'>
      <div className='layout-width-constraint'>
        <div className='bg-white'>
          <div>
            <h1 className='f2 pt0 ma0 ph6 pv4 fw6'>Legislation</h1>
            <ResponseConsumer
              response={acts}
              content={() => <List {...{ aol, acts }} />}
              pendingComponent={() => <List aol={aol} pending />}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

const List = ({ aol, acts, pending }) => (
  <ul className='list-reset ph0 bt b--dark-cerulean mv0'>
    {(pending ? [...Array(20)] : acts.filter(({ id }) => LEGISLATION_TAKEOVER_CODE || id !== TAKEOVER_INTERNAL))
      .map((act, index) => (
        <ListItem key={index} {...{ ...act, aol, pending }} />
      ))}
  </ul>
)

const ListItem = ({ aol, id, pending, title }) => {
  const isIE = useSelector(selectIsIE)

  return (
    <li className='bb b--dark-cerulean'>
      <a
        className='relative min-h3 flex items-center db no-underline hover-bg-twilight-grey'
        href={pending ? undefined : getUrl(LEGISLATION, { aol, path: id })}
      >
        <span className='absolute top-50 y--50 right7 black'>
          <Icon name='icon-arrow-right' className='w7' />
        </span>
        {pending
          ? <Skeleton className='grow-1 shrink-1 basis-auto ml5 mr14 mr10-m' />
          : (
            <span
              className={cx('ma0 pl6 pr9 flex flex-column justify-center items-start black f5 fw6', {
                'ie-min-height-flex-items-center-fix': isIE
              })}
            >
              {title}
            </span>
            )}
      </a>
    </li>
  )
}

export default LegislationMenu
